import React, { useState, useCallback, useEffect } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { useShowContext } from 'framework/show';
import SummaryAssignments from '../../summary/assignments/SummaryAssignments';
import PlannedAssignments from '../../summary/assignments/PlannedAssignments';
import ReportedHoursAnalysis from '../../summary/ReportedHours/ReportedHoursAnalysis';
import ProcessTimeline from '../../summary/ProcessTimeline';
import LightTimeline from '../../summary/LightTimeline';
import { DELEGATED_EMPLOYEE_ZONES_ALIASES } from '../../constants';
import { DashboardEmployee } from '../../types';
import { useTimelineRefresh } from './TimelineRefreshContext';

const EmployeeSummaryBottomContent = () => {
  const { data } = useShowContext<DashboardEmployee>();
  const employee = data.getData();
  const isDelegatedZone = employee?.retentionRiskPriority === DELEGATED_EMPLOYEE_ZONES_ALIASES.DELEGATED;
  const { refreshTimeline } = useTimelineRefresh();
  const [timelineKey, setTimelineKey] = useState(0);

  const handleRefreshTimeline = useCallback(() => {
    setTimelineKey(prev => prev + 1);
  }, []);

  useEffect(() => {
    refreshTimeline.current = handleRefreshTimeline;
  }, [handleRefreshTimeline, refreshTimeline]);

  return (
    <>
      <SummaryAssignments />
      <PlannedAssignments />
      <ReportedHoursAnalysis />
      {!isDelegatedZone && (
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}>
            <ProcessTimeline />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <LightTimeline key={timelineKey} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export { EmployeeSummaryBottomContent as default };
